import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AVAILABLE_PAYMENT_METHODS, PAYMENT_METHOD_KEYS, PaymentMethods } from '../../../../payment.constants';
import CheckImg from '../../../../../../images/check-grey.svg';
import Spinner from '../../../../../../ui/spinner/spinner';
import classNames from '../../../../../../utils/classnames';
import translation from '../../../../../../languages';
import useHasSelectedPaymentMethod from '../../../../hooks/use-has-selected-payment-method';

type AdyenOptionProps = TranslationProps & {
    type: PAYMENT_METHOD_KEYS;
    isActive: boolean;
    onClick: (type: PaymentMethods[PAYMENT_METHOD_KEYS]) => void;
};

const AdyenOption: FC<AdyenOptionProps> = ({ type, isActive, onClick, t }) => {
    const { paymentOptionsAvailability } = useSelector((state: RootState) => state.payment);
    const title = AVAILABLE_PAYMENT_METHODS[type].translation
        ? t(AVAILABLE_PAYMENT_METHODS[type].translation ?? '')
        : AVAILABLE_PAYMENT_METHODS[type].title;
    const hasSelectedPaymentMethod = useHasSelectedPaymentMethod();
    const optionErrorClass = hasSelectedPaymentMethod ? '' : 'error';

    return <>
        {(paymentOptionsAvailability?.get(type) === null) && (
            <div className='payment-option d-flex'>
                <Spinner size={25} />
            </div>
        )}
        {(type === PAYMENT_METHOD_KEYS.CARD || paymentOptionsAvailability?.get(type)) && (
            <div
                className={classNames('payment-option d-flex', optionErrorClass, {
                    active: isActive
                })}
                onClick={() => onClick(AVAILABLE_PAYMENT_METHODS[type])}
            >
                <div className='image-holder d-flex justify-content-center align-items-center'>
                    <img src={AVAILABLE_PAYMENT_METHODS[type].img} alt='' />
                </div>
                <div className='flex-1'>
                    <label htmlFor={AVAILABLE_PAYMENT_METHODS[type].id}>{title}</label>
                    <img className='check' src={CheckImg} alt='' />
                </div>
            </div>
        )}</>;
};

const translate = translation('payment');

export default translate(AdyenOption);
